import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";
import { RevealProvider } from "@/contexts/RevealContext";

function App() {
  return (
    <div className="App grain bg-noise-overlay" data-testid="app-root">
      <div className="bg-living" aria-hidden="true" />
      <RevealProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/story" element={<Story />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </RevealProvider>
    </div>
  );
}

export default App;
